import {Stack, Typography} from '@mui/material';
import React from 'react';

import {NetworkEnum} from 'main/analytics/gaTagsEnum';
import Icon from 'presentation/icons';
import {PendingDialog} from 'presentation/modules/booking/shared/ui/components/PendingDialog';
import {SimpleConfirmationDrawer} from 'presentation/pages/private/booking/components/ConfirmationDrawer/SimpleConfirmationDrawer';
import {translations} from 'presentation/translations-new';
import {useTelehealthCard} from './hooks/useTelehealthCard';
import {StyledCard} from './styles';

const {telehealthAddress} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;
const {loading} = translations['pt-br'].commons;

export function TelehealthCard() {
	const {
		handleCloseConfirmationDrawer,
		handleOpenConfirmationDrawer,
		handleNavigateToTelehealthFlow,
		handleConfirmAndContinue,
		handleGoToTelehealthBooking,
		isSchedulingByMedicalGuideEnabled,
		isPending,
		openSimpleConfirmationDrawer,
		theme,
	} = useTelehealthCard();

	return (
		<StyledCard elevation={0}>
			<Stack
				flexDirection="row"
				alignItems="center"
				gap={0.5}
				onClick={
					isSchedulingByMedicalGuideEnabled
						? handleConfirmAndContinue
						: handleGoToTelehealthBooking
				}
				data-tag-id={NetworkEnum.CLICK_GUIA_AGENDAR_TELECONSULTA}>
				<Stack minWidth={20}>
					<Icon
						name="remember-me-filled"
						size={20}
						color={theme.colors.brand.primary.white}
					/>
				</Stack>
				<Typography variant="body1" color="white" fontWeight={600}>
					{telehealthAddress}
				</Typography>
				<Stack minWidth={20}>
					<Icon
						name="arrow-right-filled"
						size={20}
						color={theme.colors.brand.primary.white}
					/>
				</Stack>
			</Stack>
			<SimpleConfirmationDrawer
				handleClose={handleCloseConfirmationDrawer}
				isOpened={openSimpleConfirmationDrawer}
				handleOpen={handleOpenConfirmationDrawer}
				handleConfirmAndContinue={handleNavigateToTelehealthFlow}
			/>
			<PendingDialog open={isPending} text={loading} />
		</StyledCard>
	);
}
